import api from './config';

/**
 * 获取仪表板统计数据
 */
export function getDashboardStats() {
  return api.get('/dashboard/stats');
}

/**
 * 获取最近活动
 */
export function getRecentActivity() {
  return api.get('/dashboard/recent-activity');
} 